import { getLogoByHostname } from 'src/utils/getLogoByHostname';

const LogoNoLimitWhite = () => {
  const { logo, width } = getLogoByHostname();
  return <img style={{ width: width }} src={logo} alt={'Logo'} />;
};

export default LogoNoLimitWhite;
